const data = {
  translation: {
    lbl_welcome: "Chào mừng bạn tới",
    lbl_hodo_community_events: "HODO Community Events",
    lbl_setup_sound_and_video:
      "Thiết lập thiết bị âm thanh và hình ảnh trước khi tham gia",
    lbl_join_room: "Tham gia phòng",
    lbl_join_conference: "Tham gia hội thảo",
    lbl_enter_name: "Nhập tên của bạn",
    lbl_on: "Bật",
    lbl_off: "Tắt",
    lbl_change_camera: "Chuyển đổi Camera trước hoặc sau",
    lbl_add_virtual_background: "Thêm hình nền ảo",
    lbl_vietnamese: "Tiếng Việt",
    lbl_english: "Tiếng Anh",
    lbl_french: "Tiếng Pháp",
    lbl_setting_device: "Cài đặt thiết bị",
    lbl_notification: "Thông báo",
    lbl_view_layout: "Cách trình bày",
    lbl_audio_device: "Thiết bị ấm thanh",
    lbl_speaker: "Loa",
    lbl_test: "Thử nghiệm",
    lbl_noise_suppression: "Lọc nhiễu/ Giảm tiếng ồn",
    lbl_participants: "Người đã tham gia",
    lbl_the_leaver: "Người rời đi",
    lbl_new_message: "Tin nhắn mới",
    lbl_hand_raiser: "Người giơ tay",
    lbl_error: "Lỗi",
    lbl_active_speaker_mode: "Chế độ loa đang hoạt động",
    lbl_arranging_active_speakers: "Sắp xếp loa đang hoạt động",
    lbl_audio_only_mode: "Chế độ chỉ phát âm thanh",
    lbl_personal_video_mirror: "Phản chiếu video cá nhân",
    lbl_personal_video_hidden: "Ẩn video cá nhân",
    lbl_error_check_role: "Lỗi khi kiểm tra vai trò của người dùng",
    lbl_meting: "Họp",
    lbl_room_code_is_disabled: "Mã phòng bị vô hiệu hóa",
    lbl_room_code_does_not_exist: "Mã phòng không tồn tại",
    lbl_endpoint_is_not_reachable: "Không thể truy cập điểm cuối",
    lbl_room_does_not_exist: "Phòng không tồn tại",
    lbl_accessing_disabled:
      "Truy cập phòng bằng định dạng liên kết này đã bị vô hiệu hóa",
    lbl_error_fetching_token: "Lỗi khi tìm nạp mã thông báo",
    fm_toggle_interpretation: "Chọn nghe thông dịch",
    lbl_other_options: "Lựa chọn khác",
    lbl_setting: "Cài đặt",
    lbl_you: "Bạn",
    lbl_have_a_nice_day: "Chúc một ngày tốt lành",
    lbl_join_again: "Bạn muốn tham gia lại",
    lbl_click_here: "Chỉ cần ấn vào đây",
    lbl_stream: "Phát trực tiếp",
    lbl_room: "phòng",
    lbl_rename: "Đổi tên",
    lbl_change_role: "Thay đổi vai trò",
    lbl_change_my_role: "Thay đổi vai trò của tôi",
    lbl_mute_all: "Tắt tiếng tất cả",
    lbl_exit: "Thoát",
    lbl_url_embed: "URL nhúng",
    lbl_cancel: "Huỷ bỏ",
    lbl_change: "Thay đổi",
    lbl_update_embed: "Cập nhật nhúng",
    lbl_stop_embed: "Dừng nhúng",
    lbl_embed_and_share: "Nhúng và chia sẻ",
    lbl_change_multiple_role: "Thay đổi vai trò hàng loạt",
    lbl_select_role: "Chọn vai trò",
    lbl_select_multiple_role: "Chọn nhiều vai trò",
    lbl_become_role: "Thành vai trò:",
    lbl_my_screen: "Màn hình của bạn",
    lbl_signal: "Sóng kém",
    lbl_mute_mic: "Bạn đã bị tắt tiếng",
    lbl_participants_1: "Thành phần tham gia",
    lbl_no_participants: "Không có người tham gia",
    lbl_no_suitable_participants: "Không có người tham gia phù hợp",
    lbl_input_search: "Nhập thông tin tìm kiếm",
    lbl_all: "Tất cả",
    lbl_change_permissions: "Thay đổi quyền",
    lbl_remove_participants: "Bỏ người tham gia",
    lbl_change_role_of: "Thay đổi vai trò của",
    lbl_become: "thành",
    lbl_submit_request_confirm: "Gửi yêu cầu xác nhận",
    lbl_pin: "Ghim",
    lbl_unpin: "Bỏ ghim",
    lbl_outstanding_position_for_everyone: "Vị trí nổi bật cho mọi người",
    lbl_removed_from_prominent_position: "Xoá khỏi vị trí nổi bật",
    lbl_connected_now: "Bây giờ bạn đã được kết nối",
    lbl_open_chat: "Mở cửa sổ trò chuyện",
    lbl_welcome_joined: "Chào mừng bạn đã tham gia",
    lbl_person_first: "Bạn là người đầu tiên tham gia phòng",
    lbl_sit_down:
      "Vui lòng ngồi lại và thư giãn cho đến khi những người khác tham gia",
    lbl_select_maximum_resolution: "Chọn độ phân giải tối đa",
    lbl_currently_streaming: "Hiện đang phát trực tuyến:",
    lbl_low: "Thấp",
    lbl_high: "Trung bình",
    lbl_medium: "Cao",
    lbl_sharing_screen: "Bạn đang chia sẻ màn hình của mình",
    lbl_stop_share: "Dừng chia sẻ màn hình",

    msg_error_check_role:
      "Đã xảy ra lỗi khi kiểm tra vai trò của bạn. Vui lòng kiểm tra lại vai trò của bạn hoặc liên hệ với Seed của Circle để biết thêm chi tiết.",
    msg_room_code_is_disabled:
      "Mã phòng tương ứng với liên kết này không còn hoạt động.",
    msg_room_code_does_not_exist:
      "Chúng tôi không thể tìm thấy mã phòng tương ứng với liên kết này.",
    msg_room_does_not_exist:
      "Chúng tôi không thể tìm thấy phòng tương ứng với liên kết này.",
    msg_accessing_disabled:
      "Bạn có thể bật lại tính năng này từ phần dành cho nhà phát triển trong Trang tổng quan.",
    msg_error_fetching_token:
      "Đã xảy ra lỗi khi tìm nạp mã thông báo ứng dụng. Vui lòng xem nhật ký để biết thêm chi tiết.",
    msg_embed:
      "Nhúng url và chia sẻ với mọi người trong phòng. Đảm bảo rằng bạn đang chia sẻ tab hiện tại khi lời nhắc mở ra. Lưu ý rằng không phải tất cả các trang web đều hỗ trợ được nhúng.",

    fm_toggle_sound: "{{status}} âm thanh ({{key}} + d)",
    fm_toggle_video: "{{status}} hình ảnh ({{key}} + e)",
    fm_toggle_background: "{{status}} hình nền ảo",
    fm_gird_layout_view: "Xếp lưới trong chế độ xem({{count}})",
    fm_toggle_pip: "{{status}} chế độ xem ảnh trong ảnh",
    fm_interpretation_end:
      "Phiên dịch {{text1}} đã kết thúc. Bạn được chuyển về nghe {{text2}}",
    fm_interpretation_select: "Bạn đã lựa chọn nghe {{text}}",
    fm_you_have_left_cabin: "Bạn đã rời khỏi buồng dịch",
    fm_not_connect_room: "Không thể kết nối tới phòng {{name}}",
    fm_endpoint_is_not_reachable: "Không thể truy cập điểm cuối. {{desc}}",
    fm_you_out_room: "Bạn đã rời khỏi phòng {{name}}",
    fm_fullscreen: "{{action}} toàn màn hình",
    fm_open_chat: "{{action}} cửa sổ trò chuyện",
    fm_you_content: "Bạn ({{content}})",
    fm_volume: "Âm lượng ({{number}})",
    fm_pin_screen: "{{action}} khung hình",
    fm_toggle_fullscreen: "{{text}} toàn màn hình",
    fm_toggle_sharescreen: "{{text}} chia sẻ màn hình",
    fm_block_permission: "Quyền {{device}} bị chặn",
    fm_access_permission: "Cần có quyền truy cập vào {{device}}. ",
    fm_accept_permission_system: "Bật quyền cho {{device}} từ cài đặt hệ thống",
    fm_accept_permission_browser:
      "Bật quyền cho {{device}} từ thanh địa chỉ hoặc cài đặt trình duyệt",
    fm_hands_up: "{{name}} giơ tay",
    fm_hands_up_multiple: "{{name}} và {{number}} người khác giơ tay",
    fm_joined: "{{name}} đã tham gia",
    fm_left: "{{name}} đã rời đi",
    fm_left_multiple: "{{name}} và {{number}} những người khác đã rời đi",
    fm_new_message: "Tin nhắn mới từ {{name}}",
    fm_new_message_multiple: "{{number}} tin nhắn mới",
    fm_offline:
      "Bạn hiện đang trực tuyến, trong khi chúng tôi cố gắng kết nối lại, vui lòng kiểm tra kết nối internet của bạn. {{message}}",

    fm_start: "Bắt đầu",
    fm_stop: "Dừng",
    lbl_no_msg: "Không có tin nhắn",
    lbl_hands_up: "Giơ tay",
    lbl_hands_down: "Thu tay",
    lbl_open: "Mở",
    lbl_close: "Đóng",
    lbl_activate: "Kích hoạt",
    lbl_deactivate: "Hủy kích hoạt",
    lbl_everyone: "Mọi người",
    lbl_new_msgs: "Các tin nhắn mới",
    lbl_find_participants: "Tìm người tham gia",
    lbl_roles: "Vai trò",
    lbl_participant: "Người tham gia",
    lbl_write_smt_here: "Viết cái gì đó ở đây",
    lbl_toggle_all_remote_audio_devices:
      "Tắt/Bật tiếng các thiết bị âm thanh từ xa",
    lbl_all_roles: "Tất cả vai trò",
    lbl_track_type: "Loại track",
    lbl_track_source: "Nguồn track",
    lbl_track_status: "Trạng thái track",
    lbl_mute: "Tắt tiếng",
    lbl_unmute: "Yêu cầu bật tiếng",
    lbl_apply: "Áp dụng",
    lbl_all_sources: "Tất cả các nguồn",
    lbl_all_devices: "Tất cả các loại thiết bị",
    lbl_strangers: "Người lạ",
    lbl_pin_msg: "Ghim tin nhắn",

    obj_roles: {
      lbl_presenter: "Báo cáo viên",
      lbl_broadcaster: "Diễn giả",
      lbl_panelist: "Tham luận viên",
      lbl_translator: "Thông dịch viên",
      "lbl_e-v": "Anh - Việt",
      "lbl_f-v": "Pháp - Việt",
      lbl_vietnamese: "Tiếng Việt",
      lbl_guest: "Khách",
      "lbl_guest-advanced": "Khách (Nâng cao)",
      lbl_viewer: "Người xem",
      "lbl_hls-viewer": "Người xem",
    },
    lbl_waiting_for_the_live_stream_to_start:
      "Đang đợi buổi phát trực tiếp bắt đầu",
    lbl_live_streaming: "Đang phát trực tiếp",
    lbl_stream_management: "Quản lý Stream",
    lbl_stop_recording: "Dừng ghi video",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Bạn có chắc chắn muốn kết thúc quá trình ghi không?",
    lbl_stop: "Dừng",
    lbl_starting_recording: "Đang ghi video",
    lbl_start_recording: "Bắt đầu ghi video",
    lbl_start: "Bắt đầu",
    lbl_recording_already_running: "Bản ghi đã chạy",
    lbl_browser_message:
      'Trình duyệt muốn chúng tôi nhận được xác nhận để phát Luồng Live HODO. Vui lòng nhấp vào "phát luồng" để tiếp tục.',
    lbl_select_quality: "Chọn chất lượng",
    lbl_auto: "Tự động",
    lbl_play: "Phát",
    lbl_pause: "Tạm dừng",
    lbl_the_conference_will_start_in: "Hội thảo sẽ bắt đầu sau",
    lbl_the_conference_will_begin_soon:
      "Hội thảo sẽ sớm được bắt đầu. \nBạn vui lòng ngồi xuống nghỉ ngơi và thư giãn trong thời gian chờ đợi.",
    lbl_the_conference_has_ended:
      "Hội thảo đã kết thúc, vui lòng quay lại vào thời điểm khác. \nXin cảm ơn!",
    lbl_you_can_connect_with_others: "Bạn không thể kết nối với người khác.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "Bạn đã kết nối nhưng chưa có người hoạt động trong vòng kết nối của bạn.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Hiện tại, không có người nào khác trong phòng.",
    lbl_this_role_does_not_exist: "Vai trò này không tồn tại.",
    lbl_this_role_has_not_been_published: "Vai trò này chưa được công khai.",
  },
};

export default data;
